import { AuditCampaign, auditCampaignSelectors } from '@skinsoft/entity/src/audit-campaign';
import { ThesaurusTermDataStore, thesaurusTermSelectors } from '@skinsoft/entity/src/thesaurusTerm';
import { getReadableDate, getTranslatedString, toDateTxtHMS } from '@skinsoft/ui';
import { Observable, of } from 'rxjs';
import { first, map, switchMap, take } from 'rxjs/operators';

export interface AuditCampaignFeatured {
    id: string,
    identificationNumber: string,
    title: string,
    campaignCreationDate: string,
    auditType: string,
    auditors: string[],
    campaignManager: string
}

export function toCampaignFeatured$(campaign: AuditCampaign, locale: string): Observable<AuditCampaignFeatured> {

    const featuredCampaign: AuditCampaignFeatured = {
        auditType: auditCampaignSelectors.auditType(campaign),
        auditors: auditCampaignSelectors.auditors(campaign),
        campaignCreationDate: getReadableDate(toDateTxtHMS(auditCampaignSelectors.campaignCreationDate(campaign))),
        campaignManager: auditCampaignSelectors.campaignManager(campaign),
        id: auditCampaignSelectors.id(campaign),
        identificationNumber: auditCampaignSelectors.identificationNumber(campaign),
        title: auditCampaignSelectors.title(campaign, locale)
    }

    return of(featuredCampaign).pipe(
        // Resolving audit type
        switchMap(
            (theFeaturedCampaign) => {
                if (theFeaturedCampaign.auditType) {

                    return ThesaurusTermDataStore.getInstance().fetchOne(featuredCampaign.auditType)
                        .pipe(
                            take(1),
                            map(
                                term => {
                                    return {
                                        ...theFeaturedCampaign,
                                        auditType: getTranslatedString(thesaurusTermSelectors.preferredTerm(term), locale)
                                    }
                                }
                            )
                        )
                }
                else {
                    return of(theFeaturedCampaign);
                }
            }
        )
    );
}